// extracted by mini-css-extract-plugin
export default {"container":"Backoffice-EditGeneralPage_container__EOwsG"};